import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/404')({
  component: Error404Page,
});

export function Error404Page() {
  return (
    <div className="min-h-screen grid place-items-center p-10 bg-air-primary">
      <div className="w-full max-w-xl text-center rounded-2xl bg-white p-10 shadow-md">
        <div className="text-6xl font-extrabold tracking-tight text-gray-900">404</div>
        <h1 className="mt-4 text-3xl font-semibold text-gray-900">Page Not Found</h1>
        <p className="mt-6 text-gray-600">The page you are looking for does not exist.</p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link
            to="/"
            className="rounded-md border px-6 py-3 text-base font-medium text-white bg-air-primary hover:bg-air-primary-hover active:bg-air-primary-active"
          >
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
